import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';

export const FieldsContainer = ({ children, columns }: PropsWithChildren<{ columns: number }>) => {
  return <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: '1rem' }}>{children}</Box>;
};
